import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, Fade, Icon, Slide, styled, useMediaQuery } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { brandclubStyles } from '../../../styles';
import { DIALOG_SCREEN_SIZE, TABLET_SCREEN_SIZE } from '../../../utils/constants';
import { PopupDrawerProps } from './PopupDrawerType';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '&.popup-drawer': {
    '& div.MuiDialog-paper': {
      margin: 0,
      borderRadius: 10,
      minWidth: 569,
      maxWidth: 569,
      minHeight: 400,
      color: theme.vars.palette.text.primary,
      boxShadow: 'none',
    },
    '& h2.MuiDialogTitle-root': {
      padding: '12px 13px',
    },
    '& .close-icon': {
      float: 'right',
      display: 'flex',
      width: 24,
      height: 24,
      color: theme.vars.palette.text.primary,
      cursor: 'pointer',
      position: 'relative',
      top: 7,
      right: 7,
    },
    '& .dialog-content': {
      padding: 0,
      overflowY: 'auto',
      color: theme.vars.palette.text.primary,
      ...brandclubStyles.customScrollbar,
    },

    // media queries
    [`@media screen and (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
      '& div.MuiDialog-paper': {
        width: '100vw',
        minWidth: '100vw',
        maxWidth: '100vw',
        maxHeight: '75vh',
        position: 'absolute',
        bottom: 0,
      },
    },
  },
}));

const SlideUpTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * @returns dialog that turn into bottom drawer when viewport < TABLET_SCREEN_SIZE
 */
export const PopupDrawer = ({ open, onClose, dialogProps, children }: PopupDrawerProps) => {
  const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
  const handleCloseDialog = () => onClose();

  return (
    <StyledDialog
      open={open}
      className="popup-drawer"
      onClose={handleCloseDialog}
      TransitionComponent={desktopView ? Fade : SlideUpTransition}
      {...dialogProps}
    >
      <DialogTitle>
        <Icon className="close-icon" onClick={handleCloseDialog}>
          <CloseIcon
            sx={{
              width: '100%',
              height: '100%',
            }}
          />
        </Icon>
      </DialogTitle>
      <DialogContent className="dialog-content">{children}</DialogContent>
    </StyledDialog>
  );
};
